import { Injectable, NgZone } from '@angular/core';
import { Observable, BehaviorSubject, Subject } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { ApiProvider } from '../providers/api.provider';
import {
  SectorCompress,
  Stop,
  Stops,
  RouteCompress
} from '../models/live-route';
import { DatePipe } from '@angular/common';
import { MatTableDataSource } from '@angular/material/table';
import { AuthenticationService } from './authentication.service';
import { SpinnerService } from './SpinnerService';

@Injectable({
  providedIn: 'root'
})
export class SectorService {
  private currentSectorSubject: BehaviorSubject<SectorCompress>;
  public currentSector: Observable<SectorCompress>;
  public dataSourceOnHold: MatTableDataSource<Stop>;
  public minLiveRouteStatus: number;
  public SectorID: number;
  public StopCount: number;
  public RouteDate: Date;
  private CurrentDataRoot: SectorCompress = new SectorCompress();
  public dataOnHold$: Subject<Stops> = new Subject<Stops>();
  public routeid: number;
  public userId: any;

  constructor(
    public apiProvider: ApiProvider,
    private datePipe: DatePipe,
    private authenticationService: AuthenticationService,
    public SpinService: SpinnerService
  ) {
    this.currentSectorSubject = new BehaviorSubject<SectorCompress>(null);
  }

  public get currentSectorValue(): SectorCompress {
    return this.currentSectorSubject.value;
  }

  public ResetCurrentSectprValue() {
    this.currentSectorSubject = new BehaviorSubject<SectorCompress>(null);
  }

  initialiseSector() {
    const that = this;
    if (this.SectorID > 0 && this.RouteDate != null) {
      this.CurrentDataRoot.RouteCompress = [];
      this.CurrentDataRoot.Sector_ID = this.SectorID;
      this.GetDataFromDatabase();
    } else {
      setTimeout(() => this.SpinService.spin$.next(false), 300);
    }
  }

  public async GetDataFromDatabase() {
    await this.apiProvider
      .SectorCompressByDate(
        this.SectorID,
        this.datePipe.transform(this.RouteDate, 'yyyy-MM-dd'),
        this.authenticationService.currentUserValue.UserID
      )
      .subscribe(
        (sectorCompress: SectorCompress) => {
          this.currentSectorSubject = new BehaviorSubject<SectorCompress>(
            sectorCompress
          );
          this.CurrentDataRoot= sectorCompress;
          this.currentSectorSubject = new BehaviorSubject<SectorCompress>(
            this.CurrentDataRoot
          );
          this.currentSector = this.currentSectorSubject.asObservable();

         // setTimeout(() => this.SpinService.spin$.next(false), 1000);
        },
        (err: HttpErrorResponse) => {
          this.currentSectorSubject.next(null);
        }
      );
  }

  public IncrementStopCount(routeid: number, count: number) {
    for (let i = 0; i < this.currentSectorValue.RouteCompress.length; i++) {
      if (this.currentSectorValue.RouteCompress[i].Route_ID === routeid) {
        this.currentSectorValue.RouteCompress[i].StopCount += count;
      }
    }
  }

  public DecrementStopCount(routeid: number, count: number) {
    for (let i = 0; i < this.currentSectorValue.RouteCompress.length; i++) {
      if (this.currentSectorValue.RouteCompress[i].Route_ID === routeid) {
        this.currentSectorValue.RouteCompress[i].StopCount -= count;
      }
    }
  }

  async initialiseSectorOnHold() {}
}
